import React, { Fragment, useState } from 'react'
import { appNumber,appString } from 'utils'
import './index.less'

export {AppSearchInput} from './AppSearchInput'
export {AppLookup} from './AppLookup'

export interface AppInputProps {
	dataType?: string
    readonly?: boolean
	value?: string
    format?: string
    state?:'default'|'error'|'active'|'readonly'
    prefix?: string
    unit?: string
	placeholder?: string
    forbidChars?: string
    password?:boolean
	onChange?: (value: string | number, text: string) => void
}

const initState = (props: AppInputProps) =>{
    if(props.readonly) return 'readonly'
    return props.state || 'default'
}


export const AppInput = (props: AppInputProps) => {

    const getReturnValue = (value?:string) =>{
        if(props.dataType && props.dataType=== 'number'){
            return appNumber.returnValue(value)
        }
        return value || '';

    }

    const getText = (text?:string) =>{
        if(props.dataType && props.dataType=== 'number'){
            if(text && text !== ''){
                if (isNaN(parseFloat(text.replace(/,/g, "")))) 
                    return '';
                else
                    return appNumber.format(text, props.format);
            }
            return '';
        }else{
            text = appString.clearForbidChars(props.forbidChars,text)
        }

        return text || '';
    }

    const [state, setState] = useState(initState(props))
    const [returnValue, setReturnValue] = useState(getReturnValue(props.value))

    
    const hanldFocus = () =>{
        if(props.readonly && state==='readonly') return;
        setState('active');
    }

    const hanldBlur = () =>{
        if(props.readonly) return;
        let text = getText(refInput.current.value)
        refInput.current.value = text;
        let value = getReturnValue(text)
        if(value !== returnValue){
            props.onChange && props.onChange(value, text)
            setReturnValue(value);
        }

        setState('default')
    }

    const refInput = React.createRef<HTMLInputElement>()
    

	return (
        <span className='app-input-main'>
            <div 
                className='app-input-container' 
                data-type = {props.dataType || 'string'}
                data-state = {state}
            >
                {
                    props.prefix?
                    <div className='app-input-left' >
                        <span>{props.prefix}</span>
                    </div> 
                    :<Fragment/>
                }
               
                <div className='app-input-middle'>
                    <input 
                        ref={refInput}
                        placeholder={props.placeholder || ''}
                        defaultValue={getText(props.value)}
                        onBlur={hanldBlur}
                        readOnly={props.readonly || false}
                        onFocus={e => hanldFocus()}
                        type={props.password?'password':''}
                    />
                </div>
                {
                    props.unit?
                    <div className='app-input-right'>
                        <span>{props.unit}</span>
                    </div>
                    :<Fragment/>
                }
            </div>
        </span>
	)
}



// WEBPACK FOOTER //
// ./src/qcc/AppInput/index.tsx